import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationHI from './locales/hi/translation.json';
import translationMR from './locales/mr/translation.json';
const resources = {
  en: {
    translation: translationEN,
  },
  hi: {
    translation: translationHI,
  },
  mr: {
    translation: translationMR,
  },
};

i18n
  .use(LanguageDetector) // optional for auto detection
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // default language
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
  });

export default i18n;
